var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplosion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.001 48",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(190, 33, 38)",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 9a3 3 0 0 0 3-3V3a3 3 0 0 0-6 0v3a3 3 0 0 0 3 3zM45.5 43H35.04l9.45-5.4a2.997 2.997 0 0 0-2.98-5.2l-9.19 5.25 15.29-27.18a2.995 2.995 0 0 0-5.22-2.94L27 34.89V20a3 3 0 0 0-6 0v15.59l-9.5-14.25a3.001 3.001 0 0 0-5 3.32l8.16 12.24-4.12-2.47a2.996 2.996 0 0 0-3.08 5.14L13.18 43H2.5a2.5 2.5 0 0 0 0 5h43a2.5 2.5 0 0 0 0-5zm-22.26 0H17a6.95 6.95 0 0 1 .32-2.11A7.046 7.046 0 0 1 21 36.68a2.877 2.877 0 0 1 .57-.24A6.72 6.72 0 0 1 24 36a6.821 6.821 0 0 1 2.18.35 5.844 5.844 0 0 1 .82.33 6.925 6.925 0 0 1 3.61 4.02A6.984 6.984 0 0 1 31 43h-7.76z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplosion);
export default __webpack_public_path__ + "static/media/explosion.b70cb73b17398be1cf759d716b51eb03.svg";
export { ForwardRef as ReactComponent };